const SDK_VERSION = '7.18.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
